import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import AppLoader from './AppLoader';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();
  const location = useLocation();

  // Если еще загружаем пользователя, показываем пустой div или loader
  if (loading) {
    return <AppLoader fullScreen />;
  }

  // Если пользователь не авторизован, перенаправляем на страницу входа
  if (!user) {
    const connect = location.pathname === '/settings' && new URLSearchParams(location.search).get('connect') === 'telegram';
    return <Navigate to={connect ? '/login?connect=telegram' : '/login'} replace />;
  }

  // Если пользователь авторизован, показываем защищенный контент
  return children;
};

export default ProtectedRoute;
